module.exports = __webpack_public_path__ + "static/media/concept-9-sm-3.d5161908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/concept-9-sm-3.jpg
// module id = 4471
// module chunks = 15